module.exports = __webpack_public_path__ + "static/media/visa-payment-wv.f8789b42.svg";